{
  "placeholders": {
    "enter_email": "Enter email address",
    "enter_password": "Enter password"
  },
  "fields": {
    "first_name": "First name",
    "last_name": "Last name",
    "email_address": "Email address",
    "password": "Password",
    "confirm_password": "Confirm password",
    "email": "Email",
    "course_name": "Course Name",
    "location": "Location",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "street_address": "Street Address",
    "city": "City",
    "country": "Country",
    "gender": "Gender",
    "player": "Player",
    "team": "Team",
    "series": "Series",
    "players": "Players",
    "flight": "Flight",
    "tee": "Tee",
    "slope": "Slope",
    "status": "Status",
    "start_time": "Tee Time",
    "hole": "Hole",
    "club": "Club",
    "total": "Total",
    "tees": "Tees",
    "course": "Course",
    "date": "Date",
    "member_number": "Member number",
    "birth_date": "Date of birth",
    "tee_color": "Tee color"
  },
  "actions": {
    "cancel": "Cancel",
    "edit": "Edit",
    "delete": "Delete",
    "create": "Create",
    "update": "Update",
    "select": "Select",
    "clear": "Clear",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "previous": "Previous",
    "next": "Next",
    "add": "Add",
    "save": "Save",
    "saving": "Saving...",
    "close": "Close",
    "loading": "Loading...",
    "load_more": "Load more",
    "like": "Like",
    "comment": "Comment",
    "select_all": "Select all",
    "remove": "Remove",
    "continue": "Continue",
    "submit": "Submit",
    "confirm": "Confirm",
    "show": "Show",
    "hide": "Hide",
    "delete_selected": "Delete selected",
    "undo": "Undo",
    "export_pdf": "Download PDF",
    "activate_selected": "Activate selected",
    "deactivate_selected": "Deactivate selected",
    "continue_to_payment": "Continue to payment",
    "pay_later": "Pay later",
    "submitting": "Submitting...",
    "redirecting_to_payment": "Redirecting to payment...",
    "pay_participation": "Pay participation",
    "deleted": "Deleted",
    "copy": "Copy",
    "more": "More actions",
    "deselect_all": "Deselect all"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "verified": "Verified",
    "unverified": "Unverified",
    "loading": "Loading...",
    "processing": "Processing...",
    "creating": "Creating...",
    "in_progress": "In progress",
    "playing": "Playing",
    "please_wait": "Please wait...",
    "changes_saved": "Changes saved",
    "logging_out": "Logging out...",
    "adding": "Adding...",
    "completed": "Completed"
  },
  "labels": {
    "status": "Status",
    "created": "Created",
    "actions": "Actions",
    "required": "*",
    "n_a": "N/A",
    "today": "Today",
    "total": "Total",
    "error": "Error",
    "not_set": "Not set",
    "back": "Back",
    "new": "New",
    "go_back": "Go back"
  },
  "gender": {
    "not_specified": "Not specified",
    "male": "Male",
    "female": "Female",
    "other": "Other"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "logout": "Logout",
    "roles": {
      "PLAYER": {
        "items": {
          "dashboard": "Dashboard",
          "events": "Events",
          "friends": "Friends",
          "competitions": "Competitions & Events",
          "rankings": "Rankings",
          "profile": "Profile",
          "stats": "Statistics",
          "ranking": "Ranking",
          "calendar": "Event Calendar",
          "series": "Ranking Series"
        }
      },
      "MANAGER": {
        "items": {
          "dashboard": "Dashboard",
          "events": "Events",
          "competitions": "Competitions & Events",
          "rankings": "Rankingseries",
          "administration": "Administration",
          "settings": "Settings",
          "reports": "Reports",
          "ranking": "Ranking",
          "calendar": "Calendar",
          "series": "Ranking Series",
          "pointSystems": "Point Systems",
          "courseStats": "Course Statistics",
          "payments": "Payment Report",
          "scheduleTemplates": "Schedule Templates",
          "scorecardTemplates": "Scorecard Templates",
          "createEvent": "Create Event",
          "analyticsAdmin": "Analytics",
          "templates": "Templates",
          "categories": "Categories",
          "addOns": "Add-ons",
          "polls": "Polls"
        }
      },
      "SUPERUSER": {
        "items": {
          "dashboard": "Dashboard",
          "competitions": "Competitions & Events",
          "rankings": "Rankingsseries",
          "users": "Users",
          "tenants": "Tenants",
          "administration": "Administration",
          "reports": "Reports",
          "ranking": "Ranking",
          "clubs": "Clubs",
          "calendar": "Calendar",
          "series": "Ranking Series",
          "pointSystems": "Point Systems",
          "courseStats": "Course Statistics",
          "payments": "Payment Report",
          "scheduleTemplates": "Schedule Templates",
          "scorecardTemplates": "Scorecard Templates",
          "handicapRecommendations": "Handicap Recommendations",
          "other": "Other",
          "settings": "Settings",
          "super": "Super",
          "createEvent": "Create Event",
          "analyticsAdmin": "Analytics",
          "templates": "Templates",
          "emailLog": "Emails",
          "categories": "Categories",
          "addOns": "Add-ons",
          "polls": "Polls"
        }
      }
    },
    "actions": {
      "open_menu": "Open menu",
      "close_menu": "Close menu",
      "logout": "Logout"
    },
    "menu": "Menu",
    "courseAnalytics": "Statistics",
    "megamenu": {
      "dashboard": "Dashboard",
      "events": "Events",
      "competitions": "Events",
      "ranking": "Ranking",
      "pointSystems": "Point Systems",
      "series": "Ranking Series",
      "friends": "Friends",
      "stats": "Statistics",
      "profile": "Profile",
      "administration": "Administration",
      "settings": "Settings",
      "templates": "Templates",
      "calendar": "Event Calendar",
      "reports": "Reports",
      "other": "Other",
      "super": "Super",
      "analyticsAdmin": "Analytics",
      "courseStats": "Course Statistics",
      "payments": "Payment Report",
      "scheduleTemplates": "Schedule Templates",
      "scorecardTemplates": "Scorecard Templates",
      "users": "Users",
      "handicapRecommendations": "Handicap Recommendations",
      "clubs": "Clubs",
      "tenants": "Customers",
      "createEvent": "Create Event",
      "emailLog": "Emails",
      "categories": "Categories",
      "addOns": "Add-ons",
      "polls": "Polls"
    }
  },
  "admin": {
    "user_management": "User Management",
    "manage_users_desc": "Manage user accounts and permissions",
    "all_users": "All Users",
    "failed_to_load_users": "Failed to load users"
  },
  "validation": {
    "email_required": "Email address is required",
    "email_invalid": "Please enter a valid email address",
    "password_required": "Password is required",
    "password_min_length": "Password must be at least 8 characters",
    "password_needs_uppercase": "Password must contain at least one uppercase letter",
    "password_needs_lowercase": "Password must contain at least one lowercase letter",
    "password_needs_number": "Password must contain at least one number",
    "confirm_password_required": "Please confirm your password",
    "passwords_dont_match": "Passwords do not match",
    "course_name_required": "Course name is required",
    "latitude_required": "Latitude is required",
    "longitude_required": "Longitude is required",
    "holes_must_be_between_1_18": "Number of holes must be between 1 and 18",
    "could_not_get_location": "Could not get your location. Please enter coordinates manually.",
    "geolocation_not_supported": "Geolocation is not supported by your browser",
    "validation_error": "Please check your data. Course ratings must be between 40-90 and slope ratings between 55-155.",
    "server_error_check_data": "Server error. Please check that course ratings are between 40-90 and slope ratings between 55-155.",
    "password_needs_special": "Password must contain at least one special character",
    "form_has_errors": "The form has errors. Please fix the errors before saving."
  },
  "confirm": {
    "delete": {
      "header": "Confirm Delete",
      "body": "Are you sure you want to delete this item? This action cannot be undone."
    },
    "unsaved_changes_title": "Unsaved Changes",
    "unsaved_changes": "You have unsaved changes. Are you sure you want to continue?",
    "save_and_continue": "Save changes",
    "continue_without_saving": "Continue without saving"
  },
  "users": {
    "search_placeholder": "Search by name or email...",
    "search_failed": "Failed to search users",
    "no_results": "No users found"
  },
  "breadcrumbs": {
    "welcome_back": "Welcome back",
    "user_management": "User Management",
    "scorecard_management": "Scorecard Management",
    "scorecard_view": "Scorecard",
    "profile": "Profile",
    "administration": "Administration",
    "settings": "Settings",
    "competition_calendar": "Event Calendar",
    "new_competition": "New Event",
    "payment_report": "Payment report",
    "reports": "Reports"
  },
  "batch_actions": "Actions",
  "batch_actions_disabled": "Select items first",
  "loading": "Loading...",
  "optional": "Optional",
  "rankings": {
    "title": "Ranking Series",
    "subtitle": "Manage ranking series and leaderboards",
    "series_count_one": "{{count}} ranking series",
    "series_count_other": "{{count}} ranking series",
    "no_series": "No ranking series yet",
    "create_first": "Create Your First Ranking",
    "create_ranking_series": "Create ranking series",
    "edit_ranking_series": "Edit Ranking Series",
    "update_ranking_series": "Update Ranking Series",
    "configure_subtitle": "Configure ranking series",
    "failed_to_load": "Failed to load rankings",
    "failed_to_load_series": "Failed to load ranking series",
    "failed_to_save": "Failed to save ranking series",
    "failed_to_delete": "Failed to delete ranking series",
    "deleted_success": "Ranking series deleted",
    "created_success": "Ranking series created",
    "updated_success": "Ranking series updated",
    "confirm_delete": "Are you sure you want to delete \"{{name}}\"?",
    "saving": "Saving...",
    "fields": {
      "name": "Name",
      "name_required": "Name is required",
      "name_placeholder": "e.g., 2024 Club Championship",
      "description": "Description",
      "description_placeholder": "Optional description",
      "season_year": "Season Year",
      "start_date": "Start Date",
      "start_date_required": "Start date is required",
      "end_date": "End Date",
      "calculation_method": "Calculation Method",
      "calculation_method_points": "Points Table (position-based points)",
      "calculation_method_stableford_hcp": "Stableford Points (handicap, sum of stableford scores)",
      "calculation_method_stableford_scr": "Stableford Points (scratch, sum of stableford scores)",
      "calculation_help_points": "Award points based on finishing position using point allocation tables",
      "calculation_help_stableford": "Calculated by summing the stableford points from competitions (based on handicap or scratch selection)",
      "maximum_events": "Maximum Events Counted (Optional)",
      "maximum_events_placeholder": "e.g., 6",
      "maximum_events_help_optional": "Leave empty to count all events. Set a number to count only best N events (e.g., best 6 of 10)",
      "tie_handling": "Tie Handling",
      "tie_handling_tied_best": "Tied Best - All tied players get best position points (most generous)",
      "tie_handling_split": "Split Points - Average points between tied players (fair)",
      "tie_handling_strict": "Strict Countback - Use countback to break all ties (competitive)",
      "tie_handling_help": "How to award points when players tie. Example: 3 players tie for 2nd (pts: 17, 15, 13). Tied Best: all get 17 pts. Split: all get 15 pts. Strict: countback determines 2nd, 3rd, 4th → 17, 15, 13 pts",
      "point_system": "Default Point System (Optional)",
      "point_system_none": "-- No default (choose per event) --",
      "point_system_help": "Can be overridden when linking events",
      "is_public": "Public",
      "is_public_help": "When selected, players will see this ranking and its leaderboard",
      "category": "Category",
      "importance_category": "Importance category",
      "tenant": "Club",
      "tenant_required": "Club is required",
      "tenant_placeholder": "-- Select club --"
    },
    "table": {
      "name": "Name",
      "season": "Season",
      "period": "Period",
      "method": "Method",
      "events": "Events",
      "status": "Status",
      "actions": "Actions",
      "best_x_of_y": "Best {{max}} of Y",
      "all_events": "All Events",
      "stableford": "Stableford",
      "tenant": "Club"
    },
    "status": {
      "draft": "DRAFT",
      "active": "ACTIVE",
      "completed": "COMPLETED",
      "archived": "ARCHIVED"
    },
    "actions": {
      "view_leaderboard": "View Leaderboard",
      "manage_events": "Manage Events",
      "back_to_rankings": "Back to Rankings",
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel"
    },
    "leaderboard": {
      "title": "{{name}}",
      "subtitle": "{{year}} Season Leaderboard",
      "no_standings": "No standings yet",
      "no_standings_help": "Link and publish series to generate rankings",
      "method_best_x": "Best {{max}} of {{total}}",
      "method_simple": "Simple Sum",
      "tie_handling": "Tie Handling",
      "tie_split": "Split Points",
      "tie_standard": "Standard",
      "events_published": "{{published}} / {{total}} published",
      "table": {
        "rank": "Rank",
        "player": "Player",
        "points": "Points",
        "events": "Events",
        "counted": "Counted",
        "first": "1st",
        "second": "2nd",
        "third": "3rd"
      },
      "method": "Method",
      "method_points_table": "Points Table",
      "method_stableford": "Stableford",
      "tie_best": "Tied Position",
      "tie_strict": "Strict Countback",
      "rank": "Rank",
      "player": "Player",
      "total": "Total",
      "event": "Event",
      "position": "Position",
      "points": "Points",
      "status": "Status",
      "actions": "Actions",
      "loading_events": "Loading events...",
      "no_events_found": "No events found",
      "failed_to_load": "Failed to load leaderboard",
      "failed_to_load_points": "Failed to load player points",
      "not_found": "Ranking series not found",
      "events_modal_title": "Events",
      "events_help": "Only scores from published events are shown in the rankings.",
      "method_stableford_hcp": "Stableford HCP",
      "method_stableford_scr": "Stableford SCR",
      "read_more": "Read more",
      "read_less": "Show less",
      "legend_not_counted": "Not counted in total points",
      "legend_excluded": "Forced exclusion"
    },
    "events": {
      "title": "Events - {{name}}",
      "subtitle": "Link competition series and publish points",
      "no_events": "No events linked yet",
      "link_first": "Link Your First Series",
      "link_series": "Link Series",
      "failed_to_load": "Failed to load events",
      "failed_to_link": "Failed to link series",
      "failed_to_publish": "Failed to publish points",
      "failed_to_unpublish": "Failed to unpublish points",
      "failed_to_delete": "Failed to delete event",
      "linked_success": "Series linked to ranking",
      "published_success": "Points published",
      "unpublished_success": "Points unpublished",
      "deleted_success": "Event removed from ranking",
      "confirm_publish": "Publish points for this event? This will calculate and assign ranking points.",
      "confirm_unpublish": "Unpublish points? This will remove all ranking points for this event.",
      "confirm_delete": "Remove \"{{name}}\" from this ranking?",
      "select_both": "Please select both a series and point system",
      "best_x_events": "Best {{max}} of {{total}} events",
      "total_events": "{{total}} total events",
      "events_published_count": "{{published}} published",
      "table": {
        "order": "#",
        "series": "Competition Series",
        "point_system": "Point system",
        "status": "Status",
        "published": "Published",
        "actions": "Actions",
        "status_published": "Published",
        "publish": "Publish",
        "unpublish": "Unpublish",
        "unpublish_help": "(for corrections)",
        "status_unpublished": "Not Published",
        "point_system_stableford_hcp": "Stableford (handicap)",
        "point_system_stableford_scr": "Stableford (scratch)"
      },
      "modal": {
        "title": "Link Competition Series",
        "point_system": "Point System",
        "point_system_select": "-- Select point system --",
        "point_system_help": "Points awarded for finishing positions",
        "cancel": "Cancel",
        "link": "Link Series",
        "competition_label": "Competition",
        "search_competition": "Search competition",
        "search_placeholder": "Search by competition name",
        "searching": "Searching...",
        "no_results": "No results",
        "competition_select": "-- Select competition --",
        "series_label": "Series",
        "series_select": "-- Select series --",
        "no_series_available": "No series available",
        "select_competition_first": "Select competition first"
      },
      "only_single_weekly": "Only individual and weekly competitions can be linked to rankings",
      "publish_title": "Publish Points",
      "unpublish_title": "Unpublish",
      "select_series": "Select series"
    },
    "no_ranking_series_available": "No ranking series available",
    "select_ranking_series_help": "Select the ranking series this competition series belongs to. Competition results will appear in the leaderboards of the selected rankings.",
    "no_series_for_season": "No ranking series for season {{season}}",
    "click_to_edit": "Click to edit",
    "delete_series_warning_title": "Delete Ranking Series",
    "delete_series_warning_body": "This ranking series has {{count}} ranking events. Deleting will remove all events, results and points. This cannot be undone.",
    "point_systems": {
      "custom": "Custom",
      "type": "Type",
      "created_success": "Point system created",
      "updated_success": "Point system updated",
      "deleted_success": "Point system deleted",
      "failed_to_save": "Failed to save point system",
      "failed_to_delete": "Failed to delete point system",
      "confirm_delete": "Are you sure you want to delete \"{{name}}\"?",
      "delete_title": "Delete point system",
      "create_for": "Create for",
      "system_default_option": "System default (all clubs)",
      "tenant_label": "Club",
      "cannot_delete_in_use_series": "The point system cannot be deleted because it is in use in {{count}} ranking series",
      "cannot_delete_in_use_events": "The point system cannot be deleted because it is in use in {{count}} ranking events",
      "cannot_delete_in_use_both": "The point system cannot be deleted because it is in use in {{seriesCount}} ranking series and {{eventsCount}} ranking events",
      "page_title": "Point Systems",
      "title": "Point Systems",
      "create_new": "Create new",
      "create_first": "Create your first point system",
      "edit_system": "Edit point system",
      "no_systems": "No point systems yet",
      "point_allocations": "Point allocations",
      "positions": "positions",
      "points_required": "Points are required",
      "points_help": "Enter points separated by commas, from highest to lowest (e.g. 50, 40, 35, 30...)",
      "system_default": "Default system"
    },
    "exclusion": {
      "exclude_result": "Exclude result",
      "include_result": "Include result",
      "exclusion_reason": "Exclusion reason",
      "excluded_success": "Result excluded from ranking",
      "included_success": "Result included in ranking",
      "failed_to_update": "Failed to update exclusion",
      "status": {
        "excluded": "Excluded",
        "not_counted": "Not counted",
        "counted": "Counted"
      }
    },
    "filters": {
      "all_seasons": "All seasons",
      "all_tenants": "All clubs",
      "no_tenant": "No club"
    },
    "cards": {
      "basic_info": "Basic info",
      "calculation_settings": "Calculation settings"
    },
    "tabs": {
      "info": "Settings",
      "events": "Competitions",
      "leaderboard": "Leaderboard"
    },
    "importance_category": {
      "major": "Major competition",
      "standard": "Standard competition",
      "minor": "Minor competition",
      "custom": "Custom"
    },
    "no_point_system": "No point system",
    "configure_point_system_first": "Set a default point system for the ranking series before linking.",
    "configure": "Configure",
    "navigate_away_title": "Go to ranking settings?",
    "navigate_away_warning": "You may have unsaved changes. Are you sure you want to go to ranking settings?",
    "public_rankings": "Public rankings"
  },
  "administration": {
    "paymentReport": {
      "status": "Status",
      "allStatuses": "All statuses",
      "search": "Search",
      "date": "Date",
      "payer": "Payer",
      "type": "Type",
      "competition": "Competition",
      "statusColumn": "Status",
      "net": "Net",
      "vat": "VAT",
      "total": "Total",
      "noPayments": "No payments",
      "summaryTotal": "Total ({{count}} payments)",
      "exportPdf": "Download PDF",
      "pdfColumns": "PDF columns",
      "statuses": {
        "created": "Created",
        "pending": "Pending",
        "completed": "Paid",
        "failed": "Failed",
        "cancelled": "Cancelled",
        "expired": "Expired",
        "partially_refunded": "Partially refunded",
        "fully_refunded": "Refunded"
      },
      "allTenants": "All clubs",
      "batchActions": "Actions",
      "batchActionsDisabled": "Select payments first",
      "refund": {
        "action": "Refund selected ({{count}})",
        "modalTitle": "Confirm refund",
        "reasonLabel": "Refund reason",
        "reasonPlaceholder": "Select reason",
        "notesLabel": "Additional information",
        "notesPlaceholder": "Optional additional information",
        "notesRequired": "Additional information is required when the reason is \"Other reason\"",
        "warning": "A refund is an irreversible action.",
        "confirmButton": "Refund",
        "successMessage": "{{count}} payments successfully refunded",
        "partialSuccessMessage": "{{successCount}} payments refunded, {{failCount}} failed",
        "failMessage": "Refund failed",
        "totalAmount": "Total refund amount",
        "reasons": {
          "CUSTOMER_REQUEST": "Customer request",
          "COMPETITION_CANCELLED": "Competition cancelled",
          "DUPLICATE_PAYMENT": "Duplicate payment",
          "PARTICIPANT_WITHDRAWN": "Participant withdrawn",
          "OVERCHARGE": "Overcharge",
          "OTHER": "Other reason"
        }
      },
      "title": "Payment Report",
      "description": "View and filter competition payments",
      "fromDate": "From",
      "toDate": "To",
      "types": {
        "competition_fee": "Competition fee",
        "registration_intent": "Registration fee"
      },
      "paytrailDetails": {
        "title": "Paytrail Payment Details",
        "loadError": "Failed to retrieve payment details from Paytrail",
        "transactionId": "Transaction ID",
        "status": "Status",
        "provider": "Payment Method",
        "amount": "Amount",
        "stamp": "Stamp",
        "reference": "Reference",
        "createdAt": "Created",
        "paidAt": "Paid",
        "filingCode": "Filing Code",
        "cardInfo": "Card Details",
        "href": "Payment Page"
      },
      "kicker": "Payment Report · Events",
      "period": "Period",
      "club": "Club",
      "filter": "Filter",
      "page": "Page",
      "paymentsUnit": "payments",
      "paymentsSection": "Payments",
      "rowsMeta": "{{rows}} rows · page {{page}} / {{pages}}",
      "pageTotal": "Page total",
      "selectedUnit": "payments selected",
      "refundSelected": "Refund selected",
      "pdfPages": "Pages",
      "pdfAllPages": "All pages ({{count}} rows)",
      "pdfCurrentPage": "This page ({{count}} rows)",
      "pdfFooterPage": "Page {{page}} / {{pages}}",
      "rowsMetaAll": "{{rows}} rows"
    },
    "users": {
      "title": "Users",
      "description": "Manage users and access rights"
    },
    "title": "Administration",
    "courseAnalytics": {
      "title": "Course Statistics",
      "description": "Analyze course difficulty, score distributions and hole-by-hole statistics"
    },
    "timeScheduleTemplates": {
      "title": "Schedule Templates",
      "description": "Manage target schedule templates for pace of play warnings and player tracking"
    },
    "pointSystems": {
      "title": "Point Systems",
      "description": "Manage ranking point systems and point distributions"
    },
    "handicapRecommendations": {
      "title": "Handicap Recommendations",
      "description": "Manage Golf Federation handicap recommendations for different play types"
    },
    "scorecards": {
      "title": "Scorecard Templates",
      "description": "Manage scorecard templates and course information"
    },
    "tenants": {
      "title": "Clubs",
      "description": "Manage clubs and communities"
    },
    "emailLog": {
      "title": "Emails",
      "description": "List of sent emails"
    },
    "polls": {
      "title": "Polls",
      "description": "Manage course feedback surveys and view results"
    }
  },
  "reports": {
    "title": "Reports",
    "courseAnalytics": {
      "title": "Course Statistics",
      "description": "Analyse course difficulty, score distributions and hole-by-hole statistics"
    },
    "paymentReport": {
      "title": "Payment Report",
      "description": "View and filter competition payments"
    }
  },
  "settings": {
    "title": "Settings"
  },
  "roles": {
    "display_names": {
      "PLAYER": "Player",
      "MANAGER": "Manager",
      "CADDIEMASTER": "Caddiemaster",
      "SUPERUSER": "Superuser"
    }
  },
  "errors": {
    "generic": "An error occurred. Please try again.",
    "export_failed": "Failed to create PDF",
    "accessDenied": "Access denied",
    "managerAccessRequired": "Viewing this page requires manager-level access rights.",
    "failed_to_load": "Loading failed",
    "failed_to_save": "Saving failed",
    "no_courses_available": "No courses available",
    "Failed to update round": "Failed to update round",
    "Irish Rumble requires exactly 4 players per team": "Irish Rumble requires exactly 4 players per team",
    "Irish Rumble requires all series to allow exactly 4 players per team.": "Irish Rumble requires all series to allow exactly 4 players per team.",
    "Irish Rumble requires at least one series to be configured before creating a round.": "Irish Rumble requires at least one series to be configured before creating a round.",
    "Cannot link to ranking series without a default point system. Please configure a default point system for": "Cannot link to ranking series without a default point system. Please configure a default point system for",
    "Minimum team size must be at least": "Minimum team size must be at least",
    "Maximum team size must be at least": "Maximum team size must be at least",
    "Minimum team size must be less than or equal to maximum team size": "Minimum team size must be less than or equal to maximum team size",
    "Cannot set team size to {min}-{max} because this competition has Irish Rumble rounds which require exactly 4 players per team": "Cannot set team size to {{min}}-{{max}} because this competition has Irish Rumble rounds which require exactly 4 players per team"
  },
  "update": {
    "title": "Updating to new version..."
  },
  "gender_plural": {
    "not_specified": "Not specified",
    "male": "Men",
    "female": "Women",
    "other": "Others"
  },
  "favorites": {
    "add": "Add to favorites",
    "remove": "Remove from favorites"
  },
  "weather": {
    "banner": {
      "warning_title": "Weather Warning",
      "delayed_title": "Play Suspended",
      "eta": "Estimated resumption time {{time}}",
      "no_eta": "Play will resume at a time to be announced"
    },
    "button": {
      "none_tooltip": "Weather Warning (no warnings)",
      "warning_tooltip": "Weather Warning active",
      "delayed_tooltip": "Play Suspended",
      "aria_none": "Weather Warning",
      "aria_warning": "Weather Warning active",
      "aria_delayed": "Play Suspended"
    },
    "modal": {
      "title": "Weather Warning",
      "stage_label": "Status",
      "stage_none": "No warning",
      "stage_warning": "Weather Warning",
      "stage_delayed": "Play Suspended",
      "reason_label": "Reason",
      "reason_placeholder": "E.g. Thunderstorm approaching",
      "eta_label": "Estimated resumption time (optional)",
      "eta_hint": "Leave blank if resumption time is not known",
      "reason_required": "Reason is required when a weather warning is in effect",
      "save_button": "Save",
      "cancel_button": "Cancel"
    }
  },
  "error_occurred": "An error occurred. Please try again."
}
